var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('navigator',{staticClass:"navigator",attrs:{"flag":_vm.navFlag}}),_vm._v(" "),_c('div',{attrs:{"id":"playtesteratt-page"}},[_c('attributeEdit',{attrs:{"id":"attribute-content"},on:{"confirmed":_vm.handleConfirm}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-efb54c8a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user-profile/PlayTesterAttribute.vue
// module id = null
// module chunks = 